import { render, staticRenderFns } from "./ClienteEdit.vue?vue&type=template&id=0881e8e6&"
import script from "./ClienteEdit.vue?vue&type=script&lang=js&"
export * from "./ClienteEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClienteEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports